import React, { FC } from 'react';

import classNames from 'classnames';

import { DynamicComponent, Seo, HeaderText } from '@/components';
import { HeaderSize } from '@/components/ui/HeaderText';

import { buildCanonicalUrl } from '@/core/contentfulConfig';
import { TypeProductLandingPage } from '@/core/generated-types';

const ProductLandingPageLayout: FC<TypeProductLandingPage> = (page) => {
  const {
    fields: {
      title,
      components,
      description,
      enableInternalSticky,
      categoryLPDesign,
    },
  } = page;

  const metadataFields = page.fields?.seoMetadata?.fields;

  return (
    <>
      <Seo
        title={metadataFields?.pageTitle}
        description={metadataFields?.pageDescription}
        nofollow={metadataFields?.noFollow}
        noindex={metadataFields?.noIndex}
        canonical={buildCanonicalUrl(page)}
      />
      <div
        className={classNames({
          'overflow-hidden': !enableInternalSticky,
          'text-center': categoryLPDesign,
        })}
      >
        {title && (
          <HeaderText
            size={HeaderSize.H1}
            classes={classNames('container mx-auto text-center font-bold', {
              'text-h-x3 mt-8': !categoryLPDesign,
              'text-h-x1 mt-20 mb-4': categoryLPDesign,
            })}
            text={title}
            hoverEffect
          />
        )}

        {description && (
          <p
            className={classNames('container mx-auto', {
              'text-lg pb-7 md:pb-12 border-b border-b-grey-mid-light':
                categoryLPDesign,
            })}
          >
            {description}
          </p>
        )}

        <div>
          {components?.map((component) => (
            <DynamicComponent key={component.sys.id} component={component} />
          ))}
        </div>
      </div>
    </>
  );
};

export default ProductLandingPageLayout;
